// import moment from "moment";
//import config from "../config/config";
// import { utcToLocal } from "./DateHelper";
// import { decryptData, encryptData } from "./EncryptHelper";
import dateFormat from "dateformat";
import React, { useMemo, useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";


export const numberToOrdinal = (number) => {
  const remainder10 = number % 10;
  const remainder100 = number % 100;

  if (remainder10 === 1 && remainder100 !== 11) {
    return `${number}st`;
  } else if (remainder10 === 2 && remainder100 !== 12) {
    return `${number}nd`;
  } else if (remainder10 === 3 && remainder100 !== 13) {
    return `${number}rd`;
  } else {
    return `${number}th`;
  }
};

export const getInitials = (name) => {
  const initials = name
    .split(" ")
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();

  return initials;
};

export const profilePic = (
  firstName,
  lastName,
  pic,
  radius = "30px",
  fontSize = "10px",
  display = "block"
) => {
  if (display !== "block") {
    return "";
  } else if (pic) {
    return <img src={`${process.env.REACT_APP_ASSETS_URL}/${pic}`} alt="img" />;
  } else {
    let name = firstName + " " + lastName;

    return (
      <div className="user-avatar" style={{ height: radius, width: radius, fontSize: fontSize }}>
        {getInitials(name)}
      </div>
    );
  }
};

export const checkPermission = (route, action = 'view') => {
  const user_data = localStorage.getItem("user_data") ? localStorage.getItem("user_data") : {};//decryptData(localStorage.getItem("user_data")) : {};

  return user_data.urole_permission?.[route]?.[action] ?? false;
};

export const formatDataBeforeSend = (data, inputFields, formatOptions) => {
  const filterData = {};

  Object.entries(inputFields).forEach(([key, value], index) => {
    filterData[key] = value ? value : data[key] ? data[key] : ''; // Assign the value to `filterData`
    //console.log(`Index: ${index}, Key: ${key}, Value: ${value}`);
  });

  if (formatOptions) {
    formatOptions.forEach(function (item) {
      if (item.type == 'react-select') {
        filterData[item.column] = filterData[item.column]?.value ?? '';
      } else if (item.type == 'react-select-multiple') {
        let temp = [];
        filterData[item.column]?.forEach(function (val) {
          temp.push(val.value);
        });
        filterData[item.column] = temp.join(',');
      } else if (item.type == 'react-datepicker') {
        filterData[item.column] = filterData[item.column] ? dateFormat(filterData[item.column], "dd-mm-yyyy") : '';
      } else if (item.type == 'react-timepicker') {
        if (!filterData[item.column] || filterData[item.column] == '00:00:00') {
          filterData[item.column] = '';
        } else {

          // This works for react-time-picker
          const now = new Date(Date.parse('2024-01-01 ' + filterData[item.column]));
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');

          filterData[item.column] = `${hours}:${minutes}:${seconds}`;
        }
      } else if (item.type == 'file' && filterData[item.column] == null) {
        filterData[item.column] = '';
      }
      // else if(item.type='hidden'){
      //   filterData[item.column] = filterData[item.labelColumn] ? filterData[item.labelColumn] : filterData[item.column];
      // }
    });
  }
  //console.log('filterdata2 =>',filterData);
  let formData = new FormData();
  for (let key in filterData) {
    formData.append(key, (key?.endsWith('_is_active') ? (filterData[key] ? 1 : 0) : filterData[key]));
  }

  return formData;
}

export const formatDataBeforeDisplay = (data, formatOptions) => {
  const formData = JSON.parse(JSON.stringify(data));

  Object.keys(formData).forEach(function (item) {
    formData[item] = data[item] ?? '';
  });
  //console.log('form =>',formData);
  if (formatOptions) {
    formatOptions.forEach(function (item) {
      if (item.type == 'react-select') {
        formData[item.column] = { value: formData[item.column], label: formData[item.labelColumn] };
      } else if (item.type == 'react-datepicker') {
        if (!formData[item.column] || formData[item.column] == '0000-00-00') {
          formData[item.column] = null;
        } else {
          formData[item.column] = new Date(Date.parse(formData[item.column]));
        }
      } else if (item.type == 'react-timepicker') {
        if (!formData[item.column] || formData[item.column] == '00:00:00') {
          formData[item.column] = null;
        } else {

          // This is for react-time-picker
          formData[item.column] = new Date('2024-04-24 ' + formData[item.column]);
        }
      }
    });
  }

  return formData;
}

// export const formatDataBeforeView = (data, formatOptions) => {
//   const formData = JSON.parse(JSON.stringify(data));

//   Object.keys(formData).forEach(function(item) {
//     formData[item] = data[item] ?? '';
//   });

//   if (formatOptions) {
//     formatOptions.forEach(function(item) {
//       if (item.type == 'date') {
//         if (! formData[item.column] || formData[item.column] == '0000-00-00') {
//           formData[item.column] = '';
//         } else {
//           formData[item.column] = dateFormat(Date.parse(formData[item.column]), 'dd/mm/yyyy');
//         }
//       } else if (item.type == 'time') {
//         if (! formData[item.column] || formData[item.column] == '00:00:00') {
//           formData[item.column] = '';
//         } else {
//           formData[item.column] = formatAMPM(new Date(Date.parse('2024-04-30 ' + formData[item.column])));
//         }
//       } else if (item.type == 'datetime') {
//         if (! formData[item.column] || formData[item.column] == '0000-00-00 00:00:00') {
//           formData[item.column] = '';
//         } else {
//           formData[item.column] = utcToLocal(formData[item.column]);
//         }
//       } else if (item.type == 'yesNo') {
//         formData[item.column] = formData[item.column] == 1 ? 'Yes' : 'No';
//       } else if (item.type == 'capitalize') {
//         formData[item.column] = capitalize(formData[item.column]);
//       }
//     });
//   }

//   return formData;
// }

export const cacheToStorage = (key, data) => {
  // if (! config.isCache) {
  //   return;
  // }

  let currentTime = dateFormat('', "dd mmm yyyy HH:MM:ss");

  const dataToStore = {
    [key]: data,
    time: currentTime
  };

  localStorage.setItem(key, dataToStore); //encryptData(dataToStore)
}
export const allDescriptionKeys = ['description', 'comment', 'htmlContent', 'service_description', 'step_description', 'price_description', 'member_comment', 'blog_content']

export const validorSettings = () => {
  return {
    messages: {
      max: 'The :attribute must be at most :max digits',
      min: 'The :attribute must be at least :min digits',

      // email: 'Please enter an valid email',
      // url: 'Please enter an valid URL',
      // default: 'Validation has failed!'
    },
    autoForceUpdate: this
  }
}

export const formatAMPM = (date) => {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours || 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;

  return hours + ':' + minutes + ' ' + ampm;
}

export const capitalize = (value) => {
  if (!value)
    return '';

  return value.charAt(0).toUpperCase() + value.slice(1);
}

export const decodeHtmlEntities = (encodedString) => {
  const elem = document?.createElement('textarea');
  elem.innerHTML = encodedString;
  return elem.value;
}

export const decodeHtmlEntities1 = (encodedString) => {
  const elem = document?.createElement('textarea');
  elem.innerHTML = encodedString;
  return elem.value;
}

export const paymentModeLabels = (payment_mode) => {

  if (payment_mode == 'bank-transfer') {
    return 'Bank Transfer';
  }
  else if (payment_mode == 'cash') {
    return 'Cash';
  }
  else if (payment_mode == 'cheque') {
    return 'Cheque';
  }
  else {
    return '';
  }
}

export const checkBadgeColour = (statusType) => {
  switch (statusType) {
    case "1":
      return `badge-soft-success`
    case "0":
      return `badge-soft-warning`;
    default:
      return `badge-soft-success`
  }
}

export const checkBadgeStatus = (status) => {
  switch (status) {
    case "1":
      return `Active`
    case "0":
      return `InActive`;
    default:
      return `Active`
  }
}

export const checkBadgeStatusForAdvantage = (status) => {
  switch (status) {
    case "1":
      return `Show`
    case "0":
      return `Hide`;
    default:
      return `Show`
  }
}

export const urlEndPoint = {
  TestimonialListUrl: '/testimonials-list',
  TestimonialAddUrl: '/add-testimonials',
  TestimonialEditUrl: '/edit-testimonials',
  TeamListUrl: '/teams-list',
  TeamAddUrl: '/add-team',
  TeamEditUrl: '/edit-team',
  ContactListUrl: '/contacts-list',
  ContactViewUrl: '/contacts-view',
  PartnerListUrl: '/partners-list',
  PartnerAddUrl: '/add-partner',
  PartnerEditUrl: '/edit-partner',
  AdvantageListUrl: '/advantage-list',
  AdvantageAddUrl: '/add-advantage',
  AdvantageEditUrl: '/edit-advantage',
  RecuitmentEditUrl: '/recuitment-update',
  ContactEditUrl: '/edit-contact',
  AboutUsListUrl: '/aboutus-list',
  AboutUsAddUrl: '/add-aboutus',
  MissionVissionUrl: '/about-mission-vision',
  MainPriorities: '/about-main-priorities',
  ValuableTeam: '/about-valuable-team',
  RecruitmentProcessAddUrl: '/about-recruit-process-add',
  RecruitmentProcessEditUrl: '/about-recruit-process-edit',
  RecruitmentProcessListUrl: '/about-recruit-process-list',
  AboutUsProcessUrl: '/about-us-process',
  AboutUsPartnerUrl: '/about-us-partner',
  RecruitingProcessListUrl: '/recruiting-process-list',
  RecruitingProcessFormUrl: '/recruiting-process-form',
  RecruitingProcessEditUrl: '/recruiting-process-edit',
  RecruitingProcessAddUrl: '/recruiting-process-add',

  BlogDetailsFormUrl: '/blog-details-form',
  getCategoryFormUrl: '/category-list',
  getBlogListUrl: '/blogs-list',
  blogAddUrl: '/add-blog',
  blogEditUrl: '/edit-blog',
  homePageUrl: '/home-page',

  socialMediaUrl: '/social-url',
  serviceUrl: '/service-list',
  serviceAddUrl: '/service-add',
  serviceEditUrl: '/service-edit',

  serviceRecruitUrl: '/service-recruit-list',
  serviceRecruitAddUrl: '/service-recruit-add',
  serviceRecruitEditUrl: '/service-recruit-edit',

  serviceProcessUrl: '/service-process-list',
  serviceProcessAddUrl: '/service-process-add',
  serviceProcessEditUrl: '/service-process-edit',
  newsLetterSubscriptionList: '/newsletter-subscription-list',
  privacyPolicyDetails: '/privacy-policy',
  facilityUrl: '/all-facilities',
  facilityListUrl: '/facility-list',
  profileForm: '/profile-form',
  userList: '/user-list',
  accountExecutive: '/account-executive',
  notificationList: '/notification-list',
  settings: '/settings',
  clientSelection: '/client-section',
  resetPassword: '/Reset',
  jobDetailsPage: '/Jobdetails'

}

export const truncateText = (text, maxLength = 30) => {
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
}


export const validateImageDimensionsForHomeBanner = (file, expectedWidth, expectedHeight) => {
  return new Promise((resolve) => {
    if (!file || !file.type.startsWith('image/')) {
      toast?.error("Invalid file type. Please upload an image.");
      return resolve(false);
    }

    const img = new Image();
    const objectUrl = URL?.createObjectURL(file);

    img.onload = () => {
      URL?.revokeObjectURL(objectUrl);
      const isValid = img.width === expectedWidth && img.height === expectedHeight;
      if (!isValid) {
        toast?.error(`Image dimensions must be ${expectedWidth} x ${expectedHeight}px.`);
      }
      resolve(isValid);
    };

    img.onerror = () => {
      URL?.revokeObjectURL(objectUrl);
      toast?.error("Failed to load image for dimension check.");
      resolve(false);
    };

    img.src = objectUrl;
  });
};

export const checkImageAspectRatio = (file, expectedRatio = 1 / 1, tolerance = 0.01) => {
  return new Promise((resolve) => {
    const img = new Image();

    img.onload = () => {
      const actualRatio = img.width / img.height;
      const isValid = Math.abs(actualRatio - expectedRatio) < tolerance;
      if (!isValid) {
        // toast?.error(`Image dimensions must be 1:1 aspect ratio`);
      }
      resolve(isValid);
    };

    img.onerror = () => {
      // reject(new Error("Failed to load image."));
      toast?.error("Failed to load image for dimension check.");
      resolve(false);
    };

    img.src = URL.createObjectURL(file);
  });
};

export const validateImageDimensionsForBlogBanner = (file, expectedWidth, expectedHeight) => {
  return new Promise((resolve) => {
    if (!file || !file.type.startsWith('image/')) {
      toast?.error("Invalid file type. Please upload an image.");
      return resolve(false);
    }

    const img = new Image();
    const objectUrl = URL?.createObjectURL(file);

    img.onload = () => {
      URL?.revokeObjectURL(objectUrl);
      const isValid = img.width === expectedWidth && img.height === expectedHeight;
      if (!isValid) {
        // toast?.error(`Image dimensions must be ${expectedWidth} x ${expectedHeight}px.`);
      }
      resolve(isValid);
    };

    img.onerror = () => {
      URL?.revokeObjectURL(objectUrl);
      toast?.error("Failed to load image for dimension check.");
      resolve(false);
    };

    img.src = objectUrl;
  });
};

export const badgeColorChangeCommon = (status) => {
  switch (status) {
    case "In Progress":
      return `canditate-box-color-warning`
    default:
      return `canditate-box-color-success`
  }
}


export const staticTimeArr = Array.from({ length: 68 }, (_, i) => {
  const totalMinutes = 420 + i * 15;
  const hours = String(Math.floor(totalMinutes / 60)).padStart(2, '0');
  const minutes = String(totalMinutes % 60).padStart(2, '0');
  return {
    id: totalMinutes,
    Time: `${hours}:${minutes}`,
  };
});


export const multiplyTimeInMinutes = (timeStr, multiplier) => {
  // Split the time string into hours, minutes, and seconds
  const [hours, minutes, seconds] = timeStr.split(':').map(Number);

  // Convert total time to minutes
  const totalMinutes = (hours * 60) + minutes + (seconds / 60);

  // Multiply by the given multiplier
  const result = totalMinutes * multiplier;

  return result;
}

export const accordionCheckboxColour = (status) => {
  switch (status) {
    case "Video Interview":
      return `#c5bdfd`
    case "Drug Screening":
      return `#aef2f1`;
    case "DOT Medical Card":
      return `#f6e5b7`;
    case "Road test":
      return `#f7b8b8`;
    case "Quals Cert":
      return `#c5bdfd`;
    default:
      return `#c5bdfd`
  }
}

export const statusChange = (status) => {
  switch (status) {
    case "Road Test Ready":
      return `road test ready`
    case "In Progress":
      return `in progress`;
    case "Hired":
      return `hired`;
    case "FADV Eligible":
      return `eligible`;
    case "Leads":
      return `leads`;
    case "Offer Sent":
      return `offer sent`;
    default:
      return `road test ready`
  }
}

export const AssessmentsListStatus = (status) => {
  switch (status) {
    case "Road Test Ready":
      return `Road Test Ready`
    case "Hired":
      return `Hired`;
    case "FADV Eligible":
      return `Eligible`;
    // case "Leads":
    //   return `Leads`;
    case "Offer Sent":
      return `Offer Sent`;
    case "Offer Sent":
      return `Offer Sent`;
    case "In Progress":
      return `In Progress`;
    default:
      return `Road Test Ready`
  }
}

export const AssessmentsListStatusWithoutInprogress = (status) => {
  switch (status) {
    case "Road Test Ready":
      return `Road Test Ready`
    case "Hired":
      return `Hired`;
    case "FADV Eligible":
      return `Eligible`;
    case "Leads":
      return `Leads`;
    case "Offer Sent":
      return `Offer Sent`;
    case "Offer Sent":
      return `Offer Sent`;
  }
}

export const RejectedOrInEligible = (status) => {
  switch (status) {
    case "In-Eligible For Hire":
      return `in-eligible for hire`
    case "Rejected":
      return `rejected`;
    default:
      return `rejected`
  }
}

export const checkBigScreenSize = () => {
  const width = window.innerWidth;
  if(width>2000){
    return true
  }
};

export const capitalizeFirstLetter = (string) => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};

// Returns IANA timezone string (e.g., "Asia/Kolkata", "America/New_York")
export function getLocalTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

// Returns UTC offset string (e.g., "+05:30", "-04:00")
export function getUTCOffset() {
  const offsetMinutes = new Date().getTimezoneOffset();
  const absMinutes = Math.abs(offsetMinutes);
  const hours = String(Math.floor(absMinutes / 60)).padStart(2, '0');
  const minutes = String(absMinutes % 60).padStart(2, '0');
  const sign = offsetMinutes <= 0 ? '+' : '-';
  return `${sign}${hours}:${minutes}`;
}

// Returns both timezone and UTC offset
export function getTimezoneInfo() {
  return {
    timezone: getLocalTimezone(),
    offset: getUTCOffset()
  };
}

export const RoadTestScheduleStatus = (status) => {
  switch (status) {
    case "pending":
      return `Road Test Scheduled`
      case "Pending":
      return `Road Test Scheduled`
    case "Completed":
      return `Road Test Completed`;
    case "completed":
      return `Road Test Completed`;
    case "complete":
      return `Road Test Completed`;
  }
}

export const RoadTestScheduleColour = (status) => {
  switch (status) {
    case "pending":
      return `for-type-scheduled-color`
    case "Pending":
      return `for-type-scheduled-color`
    case "Completed":
      return `for-type-completed-color`;
    case "completed":
      return `for-type-completed-color`;
      case "complete":
        return `for-type-completed-color`;
    default:
      return `for-type-schedule-color`
  }
}

export const AssessmentsListStatusWithoutLeadAndInProgress = (status) => {
  switch (status) {
    case "Road Test Ready":
      return `Road Test Ready`
    case "Hired":
      return `Hired`;
    case "FADV Eligible":
      return `Eligible`;
    case "Offer Sent":
      return `Offer Sent`;
    case "Offer Sent":
      return `Offer Sent`;
    default:
      return `Road Test Ready`
  }
}

// helpers/fileTypeChecker.js
export async function checkFileType(url) {
  try {
    // First, try HEAD request
    let response = await fetch(url, { method: 'HEAD' });
    let contentType = response.headers.get('Content-Type');

    if (contentType) {
      if (contentType.includes('pdf')) {
        return { type: 'pdf', mime: contentType };
      }
      if (
        contentType.includes('msword') ||
        contentType.includes('officedocument.wordprocessingml')
      ) {
        return { type: 'word', mime: contentType };
      }
    }

    // If no good Content-Type, fetch first bytes
    response = await fetch(url);
    const buffer = await response.arrayBuffer();
    const bytes = new Uint8Array(buffer).subarray(0, 8);

    // PDF magic number: "%PDF" → 0x25 0x50 0x44 0x46
    if (bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46) {
      return { type: 'pdf', mime: 'application/pdf' };
    }

    // DOCX magic number: ZIP format → 0x50 0x4B 0x03 0x04
    if (bytes[0] === 0x50 && bytes[1] === 0x4B && bytes[2] === 0x03 && bytes[3] === 0x04) {
      // Could be DOCX, XLSX, PPTX — need extra check
      const text = new TextDecoder().decode(bytes);
      return { type: 'word', mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' };
    }

    // DOC (old format) magic number: D0 CF 11 E0
    if (bytes[0] === 0xD0 && bytes[1] === 0xCF && bytes[2] === 0x11 && bytes[3] === 0xE0) {
      return { type: 'word', mime: 'application/msword' };
    }

    return { type: 'unknown', mime: contentType || null };
  } catch (error) {
    console.error('Error checking file type:', error);
    return { type: 'error', mime: null };
  }
}

export const formatUSPhone = (number) => {

  const digits = number?.replace(/\D/g, ""); // strip non-digits
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return number;
}

export function getVideoUrl(url, options = {}) {
  try {
    const { autoplay = 0, mute = 0 } = options;

    if (!url) return "";

    const parsed = new URL(url);
    const hostname = parsed.hostname;

    const isYouTube =
      hostname.includes("youtube.com") ||
      hostname.includes("youtu.be");

    const isFacebook =
      hostname.includes("facebook.com") ||
      hostname.includes("fb.watch");

    // -----------------
    // YOUTUBE
    // -----------------
    if (isYouTube) {
      let videoId = null;

      // youtu.be/VIDEO_ID
      if (hostname.includes("youtu.be")) {
        videoId = parsed.pathname.slice(1);
      }

      // youtube.com/watch?v=VIDEO_ID
      if (parsed.searchParams.get("v")) {
        videoId = parsed.searchParams.get("v");
      }

      // youtube.com/shorts/VIDEO_ID
      if (parsed.pathname.includes("/shorts/")) {
        videoId = parsed.pathname.split("/shorts/")[1];
      }

      if (!videoId) return url;

      return `https://www.youtube.com/embed/${videoId}?autoplay=${autoplay}&mute=${mute}&rel=0&modestbranding=1&playsinline=1`;
    }

    // -----------------
    // FACEBOOK
    // -----------------
    if (isFacebook) {
      return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
        url
      )}&show_text=false&autoplay=${autoplay}&mute=${mute}`;
    }

    return url;
  } catch (err) {
    return url;
  }
}






